import { render, staticRenderFns } from "./TopBarDropdownSubItem.vue?vue&type=template&id=0c709290&scoped=true"
import script from "./TopBarDropdownSubItem.vue?vue&type=script&lang=js"
export * from "./TopBarDropdownSubItem.vue?vue&type=script&lang=js"
import style0 from "./TopBarDropdownSubItem.vue?vue&type=style&index=0&id=0c709290&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c709290",
  null
  
)

export default component.exports